import React from "react";

export default function GridEmptyCell({ tdProps, style, className }) {
    const props = { style: style, ...tdProps };
    if (className)
        props.className = className;

    return <td {...props} />;
}